import React, {PropsWithChildren} from 'react';
import {BoxProps} from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import {StackProps, VStack} from '../../layout/layout.styled';

export const FormControlLabel = styled(Typography).attrs(() => ({
    variant: 'caption'
}))``;

type Props = PropsWithChildren<StackProps & {
    labelText: string
    'data-testid'?: string
    labelProps?: BoxProps
}>

export const FormControl = ({
    'data-testid': dataTestId = 'FormControl',
    children,
    labelText,
    labelProps,
    ...stackProps
}: Props) => {
    return (
        <VStack spacing={'10px'}
            {...stackProps}
            data-testid={dataTestId}
        >
            <FormControlLabel data-testid={'FormControlLabel'} {...labelProps}>
                {labelText}
            </FormControlLabel>

            {children}
        </VStack>
    );
};

